/** @format */
/*
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

const Categoys = ({ categories }) => {
  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 6 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 6 },
    tablet: { breakpoint: { max: 1024, min: 768 }, items: 4 },
    mobile: { breakpoint: { max: 768, min: 0 }, items: 3 },
    smmobile: { breakpoint: { max: 640, min: 0 }, items: 2 },
    xsmobile: { breakpoint: { max: 440, min: 0 }, items: 2 },
  };

  return (
    <div className='w-[95%] mx-auto py-4 sm:py-1'>
      <Carousel
        swipeable={true}
        draggable={true}
        showDots={false}
        responsive={responsive}
        ssr={true}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={2500}
        arrows={true}
        keyBoardControl={true}
        transitionDuration={500}
      >
        {categories.map((category, index) => (
          <Link
            to={`/products?category=${category.name}`}
            key={index}
            className='group flex items-center gap-2 p-2 rounded-xl shadow-md hover:shadow-lg transition-shadow bg-white mx-2'
          >
            <div className='w-[45px] h-[45px] rounded-full overflow-hidden border-2 border-gray-200 group-hover:scale-105 transition-transform'>
              <img
                src={category.image.url || category.image}
                alt={`Category ${category.name}`}
                className='w-full h-full object-cover'
              />
            </div>
            <span className='text-gray-700 text-sm font-semibold truncate max-w-[100px]'>
              {category.name}
            </span>
          </Link>
        ))}
      </Carousel>
    </div>
  );
};

export default Categoys;
*/

/** @format */
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useCallback, useRef } from "react";
import { Link } from "react-router-dom";

const SCROLL_AMOUNT = 250;

const Categories = ({ categories }) => {
  const scrollRef = useRef(null);

  const scroll = useCallback((direction) => {
    scrollRef.current?.scrollBy({
      left: direction === "left" ? -SCROLL_AMOUNT : SCROLL_AMOUNT,
      behavior: "smooth",
    });
  }, []);

  if (!categories?.length) return null;

  return (
    <div className='w-[95%] mx-auto px-4 sm:px-6 lg:px-4 bg-white shadow-sm rounded-md pt-2'>
      {/* Header */}
      <div className='flex items-center justify-between mb-5'>
        <h2 className='text-lg sm:text-xl font-bold text-gray-900'>
          Catégories
        </h2>
        <div className='flex gap-2'>
          <button
            onClick={() => scroll("left")}
            aria-label='Défiler à gauche'
            className='w-8 h-8 flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:bg-gray-100 hover:text-gray-800 transition-colors'
          >
            <ChevronLeft size={16} />
          </button>
          <button
            onClick={() => scroll("right")}
            aria-label='Défiler à droite'
            className='w-8 h-8 flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:bg-gray-100 hover:text-gray-800 transition-colors'
          >
            <ChevronRight size={16} />
          </button>
        </div>
      </div>

      {/* Scrollable categories */}
      <div
        ref={scrollRef} // ← CORRECTION ICI
        className='flex gap-4 overflow-x-auto scrollbar-hide pb-2 scroll-smooth snap-x snap-mandatory'
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {categories.map((category, index) => (
          <Link
            to={`/products?category=${encodeURIComponent(category.name)}`}
            key={category._id ?? index}
            className='group flex-shrink-0 snap-start flex flex-col items-center gap-3 w-[100px] sm:w-[120px]'
          >
            {/* Image circle */}
            <div className='relative'>
              <div className='w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden border-2 border-gray-100 group-hover:border-indigo-400 transition-all duration-300 group-hover:shadow-lg group-hover:shadow-indigo-100'>
                <img
                  src={category.image?.url ?? category.image}
                  alt={category.name}
                  className='w-full h-full object-cover group-hover:scale-110 transition-transform duration-500'
                  loading='lazy'
                />
              </div>
              <div className='absolute inset-0 rounded-full bg-indigo-400/0 group-hover:bg-indigo-400/10 transition-colors duration-300' />
            </div>

            {/* Label */}
            <span className='text-xs sm:text-sm font-medium text-gray-700 group-hover:text-indigo-600 transition-colors text-center leading-tight line-clamp-2'>
              {category.name}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Categories;
